export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12034.9d516d4b.jpg";